const images = {
  logo: require("../../assets/logo.png")
};

export default images;
